export function videoFunction() {
    const videoBtn = $(".btn-play");

    videoBtn.on("click", function (e) {
        e.preventDefault();

        const parent = $(this).closest(".video");
        const videoSrc = $(this).data("video") + "?autoplay=1"; // + "?enablejsapi=1&autoplay=1"
        const video = '<iframe src="' + videoSrc + '" frameborder="0"  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen playsinline></iframe>';

        parent.append(video);
        setTimeout(() => {
            parent.addClass("show-video");
        }, 500);


        if ($(this).closest('.customer-story-item')) {
            const item = $(this).closest('.customer-story-item');
            item.siblings().find('iframe').remove();
            item.siblings().find('.video').removeClass('show-video');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoFunction.js